import React from 'react';

import Router from './Router/Router';


import './styles/styles.css';

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;